import React from "react";
import { ChevronLeft, ChevronRight } from "../Icons";

const Pagination = ({
  currentPage,
  onPageChange,
  pageSize = 12,
  totalCount,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 50, 100],
  showPageSize = true,
}) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  if (totalPages <= 1) return null;

  const generatePages = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const pages = generatePages();

  return (
    <div className="flex items-center gap-2.5 w-full justify-center">
      {/* Page Size Selector */}
      {/* {showPageSize && (
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange?.(Number(e.target.value))}
          className="mr-4"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>
              {size}/page
            </option>
          ))}
        </select>
      )} */}

      {/* Chevron Left Button */}
      <button
        className="bg-transparent border border-[#F1F1F1] rounded-md w-7 h-7"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <ChevronLeft />
      </button>

      {/* Page Number Navigation */}
      {pages[0] > 1 && (
        <>
          <button className={`bg-transparent text-[0.85rem] rounded-md w-7 h-7 ${
              currentPage === 1
                ? "!bg-[#0068FF] border-0 text-[#FFFFFF]"
                : "text-[#666666] font-normal border border-[#F1F1F1]"
            }`} onClick={() => onPageChange(1)}>1</button>
          {pages[0] > 2 && <span>...</span>}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          className={`bg-transparent text-[0.85rem] rounded-md w-7 h-7 ${
            currentPage === page
              ? "!bg-[#0068FF] border-0 text-[#FFFFFF]"
              : "text-[#666666] font-normal border border-[#F1F1F1]"
          }`}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      ))}

      {pages[pages.length - 1] < totalPages && (
        <>
          {pages[pages.length - 1] < totalPages - 1 && <span>...</span>}
          <button
            className={`bg-transparent text-[0.85rem] rounded-md w-7 h-7 ${
              currentPage === totalPages
                ? "!bg-[#0068FF] border-0 text-[#FFFFFF]"
                : "text-[#666666] font-normal border border-[#F1F1F1]"
            }`}
            onClick={() => onPageChange(totalPages)}
          >
            {totalPages}
          </button>
        </>
      )}

      {/* Chevron Right Button */}
      <button
        className="bg-transparent border border-[#F1F1F1] rounded-md w-7 h-7"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <ChevronRight />
      </button>
    </div>
  );
};

export default Pagination;
